import React from 'react';
import { LazyScreen } from '@apps/guest/packages/layout-engine/components/CoverPhoto/CoverPhoto';
import { CoverPhotoContainer, StyledCoverPhoto } from '@apps/guest/packages/layout-engine/components/CoverPhoto/CoverPhoto.styles';
import { getImageRendition } from '@apps/guest/packages/layout-engine/layouts/layout.utils';
import { WebsiteHeaderPhotoWithAlignment } from '@apps/guest/websiteHeader';

interface CenterPhotoProps {
  photo: WebsiteHeaderPhotoWithAlignment;
}

export const CenterPhoto = (props: CenterPhotoProps) => {
  const { photo } = props;
  return (
    <LazyScreen src={photo.url} width={(600 * photo.width) / photo.height} height={600} isFullBleed={false} isChildEagerLoadRequire={false}>
      {isLoaded => {
        return (
          <CoverPhotoContainer photo={photo} position={'relative'} maxHeight={[null, null, null, 600]} width={'100%'}>
            <StyledCoverPhoto backgroundSize={'contain'} url={getImageRendition(photo.url)} />
          </CoverPhotoContainer>
        );
      }}
    </LazyScreen>
  );
};
